export default {
  language: "日本語",
  // ナビゲーション
  zdy: {
    tjsq: "アプリケーションの送信",
    czsl: "リチャージ数量",
    enterczsl: "リチャージ金額を入力してください",
    qbdz: "ウォレットアドレス",
    enterqbdz: "ウォレットアドレスを入力してください",
    sftjmcj: "注文販売価格を送信するかどうか",
    sftjmrj: "注文購入価格を送信するかどうか",
    proloss: "ストップロス",
  },
  header: {
    home: "トップページ",
    markets: "相場",
    fiat: "法定通貨取引",
    c2c: "C2C取引",
    exchange: "現物取引",
    lever: "レバレッジ",
    micro: "秒契約取引",
    myshop: "私の店舗",
    assets: "私の資産",
    help: "ヘルプセンター",
    login: "ログイン",
    sign: "登録",
    accountSet: "アカウント設定",
    tradeLog: "取引日にち",
    receiveSet: "入金設定",
    identify: "身分認証",
    jchange: "両替します",
    logout: "ログアウト",
    themedark: "ナイトモード",
    themeday: "昼間モード",
  },
  // 登录注册
  lg: {
    login: "ログイン",
    register: "登録",
  },
  // 首页
  home: {
    vol: "24H取引量",
    c01: "世界でリードしているデジタル資産取引プラットフォーム",
    c02: "130カ国を超える数百万のユーザーのために、信頼できるデジタル資産取引及び資産管理サービスを提供しています。",
    c03: "安全で信頼できます",
    c04: "5年間の暗号資産金融サービスの経験",
    c05: "専門的な分散システムとDDOS攻撃防止システム",
    c06: "世界の生態配置",
    c07: "複数の国で現地化取引サービスセンターを設立しています",
    c08: "多業務形態を一体とするブロックチェーンのグローバル展開を推進します",
    c09: "ユーザー至上",
    c10: "先行賠償支払い機制を設立します",
    c11: "投資者保護基金を設立します",
    c12: "いつでもどこでもマルチプラットフォーム端末取引",
    c13: "iOS、Android、Windowsのプラットフォームを覆い,全業務機能をサポートします",
    sweep: "ダウンロード",
    android: "Android",
    pinput:
      "お手数でございますが、メールアドレスか携帯番号をご入力してください",
    atrade: "Besencexchange のアカウントを登録して、取引を開始します",
  },
  // 底
  foo: {
    about: "私たちに関して",
    support: "ユーザーサポート",
    contact: "連絡先",
    qq: "担当者QQ",
    email: "メールアドレス",
    usdt: "市場",
    footlefta: "法的通知",
    footleftb: "プライバシーポリシー",
    footleftc: "ユーザー規約",
    footmidd: "マネーロンダリング防止について",
    footmide: "永久契約取引ルール",
    footrightf: "ダウンロード",
    footrightg: "アンドロイドダウンロード",
  },
  // 相場
  market: {
    handicap: "ハンディキャップ",
    exchange: "貨幣",
    selfmarket: "自選",
    allmarket: "総相場",
    symbol: "取引対",
    newprice: "最新価格",
    change: "上げ幅",
    highprice: "最高値",
    lowprice: "最低価",
    vol: "24H 取引量",
  },
  // 公共取引
  td: {
    buy: "購入",
    sell: "売却",
    currency: "幣種",
    num: "数量",
    time: "時間",
    limit: "限度額",
    price: "単価",
    method: "支払い方式",
    total: "総額",
    inwant: "ご入力の、、、",
    do: "操作",
    more: "ローディング",
    nomore: "以上",
    nodata: "データなし",
    trade: "取引",
    buynum: "購入数量",
    sellout: "売出す",
    buyin: "購入",
    all: "すべて",
    allbuy: "全部買い取り",
    allsell: "全部売り出し",
    buytotal: "購入総額を入力してください",
    selltotal: "売却総額を入力してください",
    buyallnum: "購入希望数量を入力してください",
    sellallnum: "売出す数量を入力してください",
    tradeTotal: "取引総額",
    doceil: "数秒後自動キャンセル",
    place: "注文する",
    waitpay: "支払いを待つ",
    paycode: "支払いコード",
    finished: "完成",
    ceiled: "キャンセル",
    payed: "支払済み",
    nofinish: "未完成",
    buyer: "買い手",
    seller: "売り手",
    callWay: "連絡方法",
    placeTime: "注文時間",
    renum: "参考番号",
    canceil: "キャンセル",
    confirm: "確認",
    pwd: "取引のパスワード",
    coincode: "通貨単位",
    pcoin: "通貨単位を選択してください",
  },
  // 法定通貨取引
  fat: {
    // LegalPayDetail
    orderLog: "注文登録",
    fatdLog: "法定通貨取引記録",
    shoper: "売買主",
    faLog: "法定通貨取引記録",
    tdType: "取引種類",
    odStatus: "注文状態",
    pwaitPay: "お手数ですが、買い手の支払いしばらくお待ちください。",
    odFinish: "注文完了",
    odCeil: "注文キャンセル",
    odPay: "お支払いになりましたので、支払いの情報をよくチェックしてください",
    tdCeil: "取引をキャンセル",
    pCeil:
      "もし売り手に金額を支払った場合、決して取引をキャンセルしないでください",
    paySure: "支払い確認",
    pdopay: "お手数ですが、売り手へのお支払いをご確認してください",
    badClick: "悪質なクリックは直接口座を凍結します",
    receivePay: "入金確認",
    payReceive: "お手数ですが、購入者のお支払いをご確認してください",
    receivePays: "入金確認完了",
    // LegalPay
    payPlease: "お手数ですが、お支払いお願い致します",
    tdPrice: "取引単価",
    tdNum: "取引数量",
    payinfo: "支払い状況",
    banknum: "銀行口座",
    realName: "実名",
    shoperZname: "売買主支店",
    shoperNum: "売買主アカウント",
    odCeil: "注文キャンセル",
    imPay: "お支払い済み、クリックしてご確認してください",
    // LegalSeller
    register_time: "登録時間",
    odtotal: "総計リスト",
    odmonth: "30日間完成リスト",
    odfinish: "完成リスト",
    odrate: "完成率",
    submit: "発表",
    phone: "携帯電話",
    mysell: "売却",
    mybuy: "仕入れ",
    realAuth: "実名認証",
    advAuth: "高級認証",
    linebuy: "オンライン購入",
    linesell: "オンライン売出す",
    tipPay:
      "24時間を超えると自動的にキャンセルするため、24時間以内に業者と連絡を取ってください",
    notlow: "最低限度額を下回ることはできません",
    nothigh: "最大限度額を超えてはいけません",
    notnum: "最大数量を超えてはいけません",
    // LegalShopDetail
    type: "タイプ",
    status: "状態",
    seeOrder: "注文書をチェック",
    withdraw: "撤回",
    abnormal: "異常",
    lowershelf: "棚をおりる",
    protection: "権力を擁護",
    apply: "権利の主張",
    psType: "お手数ですが、タイプを選択してください",
    pselect: "お手数ですが、選択してください",
    alipay: "支付宝",
    wechat: "WeChat",
    bank: "銀行カード",
    minNum: "最小取付け量",
    maxNum: "最大取引量",
    wantBuy: "仕入れ",
    pnums: "数量を入力してください",
    pmin: "最小取引量を入力してください",
    pmax: "最大取引量を入力してください",
    pnot: "最大取引量が最小取引量より小さいことはできません",
    // MyLegalShops
    myshops: "店舗",
    name: "名称",
    fiatSub: "法定貨幣属する",
    shoper_balance: "売買主し残高",
    enterShop: "入店",
    // shop_legal_pay_detail
    payedWait: "お支払い済み、ご確認お願い致します",
    yes: "はい",
    no: "いいえ",
    sd: "残高をロックする",
    journal: "残高ログ",
    business: "商売人",
    user: "ユーザー",
    backdone: "取り下げ済み",
    busbalance: "事業者残高",
    userbalance: "ユーザー残高",
  },
  ctc: {
    ctc: "C2C",
    myRelease: "発表したC2C",
    myTrade: "取引したC2C",
    and: "正確",
    balance: "残高",
    buynum: "買い入れ量",
    sellnum: "販売量",
    bankTransfer: "銀行振替",
    payim: "必ず本人が支払わなければなりません",
    pbuyNum: "お手数ですが、購入数量をご入力してください",
    pprice: "お手数ですが、単価をご入力してください",
    payway: "お手数ですが、お支払い方法を選択してください",
    psellNum: "お手数ですが、販売数を入力してください",
    suerePlace: "ご注文確認お願いいたします?",
    detail: "詳細",
    payinfo: "お支払い情報",
    Payee: "受取人",
    total: "総額",
    name: "名前",
    cardnum: "カード番号",
    receivePay: "入金確認",
    ceilConfirm: "取引キャンセル確認？",
    paySeller:
      "お手数ですが、販売者へのお支払いをご確認し悪質なクリックがございましたら直接口座を凍結されます",
    payBuyer: "お手数ですが、購入者からの情報をご確認してください",
    account: "アカウント",
    sellerPay: "お手数ですが、販売者からのお支払いをご確認してください？",
    payattion:
      "お手数ですが、お支払いの確認後は早めに売り手にお支払いください。悪意のあるクリックは口座を冻结されます",
    log: "c2c已完成订单",
  },
  // てこ
  lever: {
    nowentrust: "ご依頼",
    hisentrust: "履歴依頼",
    lvchi: "てこ倉位持ち有り",
    all: "全部",
    or: "或いは",
    gotrade: "取引開始",
    tdrecord: "取引記録",
    dealed: "成約",
    notdeal: "未成約",
    loading: "ローディング中",
    entotal: "委託総額",
    canuse: "マーケティング取引価格",
    std: "マーケティング取引価格",
    xtd: "限定取引価格",
    pprice: "お手数ですが、価格をご入力してください",
    phand: "お手数ですが、一株当たりの購入ご入力してください",
    phandsell: "販売手数を入力してください",
    pwd: "パスワード",
    ppwd: "取引パスワードを入力してください",
    psw: "取引のパスワード",
    equal: "等しい",
    times: "倍",
    timed: "倍数",
    hand: "一株",
    hands: "たくさん",
    ptimes: "お手数ですが、倍数をご選択してください",
    phands: "お手数ですが、一株当たりをご選択してください",
    contractVal: "契約マーケティング値",
    bail: "保証金",
    canBail: "有効保証金",
    charge: "取引サービス料",
    domore: "買い取る（多め）",
    doshort: "売却（空っぽ）",
    dmore: "多め",
    dshort: "空っぽ",
    sureOd: "ご注文を確認致します",
    noless: "一株当たり、、、下回ることはできません",
    nomore: "一株当たり、、、上回ることはできません",
    tdnum: "取引量",
    risk: "リスク率",
    allloss: "倉庫を持って総損益",
    onehouse: "クリック平倉",
    type: "タイプ",
    entrustPrice: "委託価格",
    openPrice: "開倉価格",
    nowPrice: "現在の価格",
    styPrice: "黒字価格をとめる",
    stsPrice: "赤字価格を止める",
    openTime: "開倉時間",
    closeTime: "平倉時間",
    rate: "手数料",
    nightFee: "日越し費用",
    loss: "損益",
    setloss: "損益を防ぐため設置する",
    expectProfit: "黒字を予期する",
    expectLoss: "赤字を予期する",
    allClose: "全部平倉",
    moreClose: "ただ多めの片手を平らげます",
    nullClose: "先に売って平倉を購入します",
    sureClose: "平倉を確認する？",
    thanZearo: "設定する値は必ず0より大きい",
    listin: "掛け値中",
    tdin: "取引中",
    closein: "平倉中",
    closed: "すでに平倉",
    revoked: "取り消す",
    revokeOrder: "注文の取り消すことをご確認してください？",
    ping: "平倉",
    revoke: "撤退する",
    sureping: "平倉を確定しますか？",
    thanzone: "設定する値は0より大きい",
  },
  // 貨幣
  cuy: {
    direction: "方向",
    total: "総計",
    price: "価格",
    sell: "売る",
    buy: "買う",
    allStation: "全般取引",
    buyPrice: "買入れ価格",
    buynum: "購入量",
    sellPrice: "売り値",
    sellnum: "販売量",
    tdPrice: "取引額",
    or: "或いは",
    tdStart: "取引開始",
    pbPrice: "お手数ですが、買入価格をご入力してください",
    pbNum: "お手数ですが、購入量をご入力してください",
    psPrice: "お手数ですが、売り値をご入力してください",
    psNum: "お手数ですが、販売量をご入力してください",
    fixPrice: "取引限定値",
    Mtrans: "取引マーケティング値",
    available: "利用可能",
    revoke: "撤回",
    loading: "ローディング中",
    confirmCancel: "キャンセルすることは確定しましたか?？",
    confirm: "確定",
    cancel: "キャンセル",
    nomore: "これ以上のデータはございません",
    evelPrice: "成約値",
  },
  // 資産
  asset: {
    confirmhuazhuan: "転送を確認？",
    assets: "資産",
    currency_account: "貨幣口座",
    lever_account: "てこ口座",
    fince_account: "法定通貨取引口座",
    change_account: "取引口座",
    micro_account: "秒契約アカウント",
    miscroAccount: "秒契約アカウント",
    assets_hua: "資金分割移動",
    all_assets: "総資産の換算",
    currency: "弊種",
    canuse: "利用可能",
    frezz: "凍結",
    conversion: "換算",
    charging: "チャージ",
    withdraw: "キャッシュ",
    address_bind: "バンドルの住所",
    address_withdraw: "キャッシュアドレスの管理",
    record: "記録",
    tbrecord: "提出貨幣記録",
    address_charge: "チャージ口座",
    address_width: "提出貨幣口座",
    copy: "コーピ",
    ercode: "コード",
    reminder: "お知らせ",
    notcharge: "上記のところにはチャージしないでください",
    ornone: "，さもなくば資産は取り戻すことができません",
    support:
      "チャージはsimple sendの方法だけをサポートしており、その他（send all）の方法でチャージしても一時的に振込できませんので、ご了承ください。",
    minnum: "最小限提出貨幣の数量",
    ratenum: "手数料",
    havenum: "着通帳数量",
    from: "から",
    to: "まで",
    transfer: "分割移動",
    tfnum: "分割移動数量",
    ptfnum: "请输入最低",
    dtfnum: "的划转数量",
    canbalance: "利用可能の残高",
    sureConfirm: "分割移動確認",
    moneyRecord: "財務記録",
    pNum: "お手数ですが、最低限の分割移動数量をご入力してください",
    leverUse: "てこの口座利用可能",
    legalUse: "法定通貨取引利用可能",
    changeUse: "取引口座の利用可能",
    microUse: "秒契約口座は使えます",
    look: "チェック",
    chargeRecord: "チャージ記録",
    status: "追跡状態",
    noopen: "この機能はしばらく開放されていません",
    enterAdderses: "お手数ですが、提出貨幣先をご入力してください",
    enterNum: "请输入提币数量",
    lessMin: "ご入力した提出貨幣数量は最小値より小さいです",
    tips01:
      "資産は上記のアドレスにチャージしないでください。さもなければ資産を取り戻すことはできません。",
    tips02:
      "チャージはsimple sendの方法だけをサポートしており、その他（send all）の方法でチャージしても一時的に振込できませんので、ご了承ください。",
    beizhu: "備考",
    pbeizhu: "お手数ですが、備考欄にご記入してください",
    add: "追加",
    addressList: "住所リスト",
    delete: "削除",
    norec: "記録なし",
    selectCurrency: "お手数ですが、貨幣種類を選択してください",
    chainType: "チェーンの種類",
    commissionLibrary: "手数料ライブラリ",
  },
  // アカウント設定
  set: {
    mycode2: "私のライセンスコード",
    copycode2: "認証コードをコピー",
    uaccont: "アカウントのセキュリティレベル:",
    strong: "強",
    middle: "中",
    weak: "弱",
    min: "低",
    heigh: "高",
    complete:
      "より多くの資料を補充し、アカウントの安全性を高めることを保証します",
    mycode: "招待コード",
    copycode: "招待コードをコピー",
    bindphone: "バインディング携帯電話",
    bindemail: "バインディングメールアドレス",
    loginpwd: "ログインパスワード",
    noBind: "未バインディング",
    binds: "バインディング",
    bind: "バインディングを行う",
    binded: "バインディング完成",
    net: "インターネットのアカウントは盗まれるリスクが高いので、定期的にパスワードを変更してアカウントの安全を保護することをお勧めします。",
    reset: "修正",
    setPsw: "取引のパスワードを設定し、取引安全を保障する。",
    goSet: "設定を行う",
    bindAccount: "バインディング振り替えアカウント",
    duihuan: "バインディングアカウントでポイント交換を行います",
    copysuccess: "コピー成功",
    copyfail: "コピー失敗",
    recopy: "お手数ですが、再度コピーしてください",
    account: "アカウン",
    detail: "詳細",
    val: "金額",
    forgetPsw: "パスワードを忘れる",
    code: "検証コード",
    getCode: "送信する",
    setPsw: "パスワードを設定",
    enterPsw: "お手数ですが、パスワードをご入力してください",
    pswFalse: "お手数ですが、二度ご入力したパスワードは一致しません",
    enterPswagain: "お手数ですが、パスワードを再度ご入力してください",
    jsetPsw: "取引のパスワードを設定",
    jenterPsw: "取引のパスワードを入力してください。",
    jenterPswagain: "取引のパスワードをもう一度入力してください。",
    enterAccount: "お手数ですが、アカウントをご入力してください",
    enterCode: "お手数ですが、検証コードをご入力してください",
    accountFalse:
      "すみませんですが、ご入力した携帯番号やメールアドレスは不規則でございます!",
    second: "秒",
    sendCode: "送信する",
    sendsucc: "送信成功",
    enterPswTwo: "お手数ですが、パスワードを2回ご入力してください",
    rest: "残り",
    yes: "はい、",
    no: "いいえ、",
    yorn: "取引パスワードを設定するかどうか",
    authenticate: "認証してください",
  },
  // 身分認証
  auth: {
    identity: "身分認証",
    name: "名前",
    idcard: "身分証明書",
    upimg:
      "お手数ですが、証明書をアップロードしてください。第一枚目は正面、第二枚目は裏、第三枚目は手持ち証明書の写真をお送りしてください。",
    submit: "提出",
    auditing: "審査中...",
    certified: "確認済み!",
    pname: "お手数ですが、名前をご入力してください",
    pidcard: "お手数ですが、証明書番号をご入力してください",
    pimg: "お手数ですが、証明書の写真をお送りしてください!",
  },
  // 受取方式
  seting: {
    pmethod: "收款方式",
    truename: "実名",
    opening: "口座名称",
    bank: "銀行カード",
    alipay: "支付宝アカウント",
    wename: "WeChat名前",
    wechat: "WeChat番号",
    pname: "お手数ですが、実名をご記入してください",
    popen: "お手数ですが、口座名称をご記入してください",
    pcard: "お手数ですが、銀行カードをご記入してください",
    palipay: "お手数ですが、支付宝アカウントをご記入してください",
    pwname: "お手数ですが、WeChat名前をご記入してください",
    pwaccount: "お手数ですが、WeChat番号をご記入してください",
    pimg1: "WeChat入金コード",
    pimg2: "アリペイを支払う",
  },
  // ヘルプセンター
  news: {
    seeall: "全てをご覧",
    helpcenter: "ログイン",
    back: "戻る",
  },
  //ようこそ
  login: {
    welcome: "ようこそ",
    phoneLogin: "携帯登録",
    emailLogin: "メールアドレス登録",
    account: "アカウント",
    psw: "パスワード",
    login: "登録する",
    nouser: "まだBesencexchangeのユーザーではありませんか？",
    goRegister:
      "すぐ登録すると、世界でリードしているデジタル資産取引プラットフォームで取引を開始できます。",
    registerFree: "無料登録",
    psw6: "パスワードは6位以下ではいけません",
  },
  register: {
    register: "登録",
    phoneRegister: "携帯登録",
    emailRegister: "メールアドレス登録",
    country: "国籍",
    enterPhone: "お手数ですが、携帯番号をご記入してください",
    enterEmail: "お手数ですが、メールアドレスをご入力してください",
    psw16: "パスワードは6 ~ 16位の間でございます",
    inviteCode: "コード",
    sel: "必要とする",
    sel2: "必要でない",
    read: "すでにご覧して同意",
    xieyi: "《ユーザー協議》",
    tips01: "国籍情報登録後は修正不可ですので、必ずきちんと選択して下さい。",
    tips02:
      "メールの検証が迷惑メールになる可能性がありますので、取り扱いにご注意下さい。",
    tips03:
      "Besencexchangeのアカウントとログインパスワードをきちんと保管してください。",
    tips04: "他のサイトと同じログインパスワードをご使用しないでください。",
    emailFalse: "入力されたメールアドレスは不規則でございます",
  },
  // 积分兑换
  jc: {
    title: "Besencexchange",
    balance: "残高",
    cannum: "使用できるJC数量",
    new: "最新の価格",
    exnum: "交換数 ",
    pnum: "お手数でございますが、JC数量をご入力してください",
    canex: "BEAU交換出来る数量",
    exnow: "すぐに両替する",
    record: "交換記録",
    exprice: "交換価格",
    extime: "交換時間",
    not: "ポイントの数が足りない",
    usenum: "JCの数量を使用する",
    out: "脱退する",
    gotd: "取引に行く",
  },
  coin: {
    manage: "投資信託",
    total: "総貨幣",
    bao: "存幣宝",
    mybao: "私の貯金は",
    profit: "予想収益",
    cuntime: "貨幣預かり時間",
    endtine: "締切時間",
  },
  team: {
    myteam: "私のチーム",
    ztnum: "直進人数",
    activenum: "チームの活動人数",
    profit: "収益",
    back: "返佣",
    cblog: "チャージの記録",
    blogs: "貨幣記録",
  },
  // k线
  kline: {
    text1: "タイムシェア",
    text2: "1分",
    text3: "5分",
    text4: "15分 ",
    text5: "30分 ",
    text6: "1時間",
    text7: "1日",
    text8: "1週間",
    text9: "1月",
  },
  frame: {
    a: "あなたは、新しい撤退命令ステータスを持っています",
    b: "取り消し",
    c: "決定する",
    con: "ユーザー様各位 取引センターで取引しているメンバーが多いためです。 銀行口座は定期的に更新されます。 ユーザーのお金の安全のために トレーディングセンターのオンラインカスタマーサービスにお問い合わせください。 送金前に最新の銀行口座情報を受け取る 幸せな生活",
  },
  miscro: {
    trade: "取引中",
    buyPrice: "購買価格",
    finshPrice: "成約価格",
    loss: "損益予想",
    times: "カウントダウン",
    mode: "取引モード",
    num: "開倉数量",
    rate: "利益率",
    up: "買上高",
    down: "は下落を買います",
    openNum: "開倉数量を入力してください",
    success: "注文成功！",
    c2c: "c2c",
    complaint: "苦情の提案",
    reply: "問題を書いてください。できるだけ早くご返事します。",
    complaintList: "苦情提案リスト",
    compplintReply: "返信：",
    complanitDescription: "説明内容を入力してください",
    reetpwd: "パスワードの変更",
    foundedOn: "作成",
    commonProblem: "よくある問題",
    statement: "説明",
    about: "STAREXについて",
    everyone: "誰でもCEO",
    program: "STAREXグローバルパートナー計画",
    about: "Besencexchangeについて",
    everyone: "誰でもCEO",
    program: "Besencexchangeグローバルパートナー計画",
    program2: "パートナー計画",
    myMine: "私の鉱場：",
    friend: "私の鉱山仲間",
    myRank: "私のレベル：",
    accumulted: "累計コミッション：",
    copyLinks: "コピープロモーションリンク",
    moneyVein: "人脈がお金の脈に変わる",
    example: "コミッションの例",
    enterQuantity: "数量を入力してください",
    contractBalance: "契約口座残高",
    submitRepeatdely: "提出中です。繰り返し提出しないでください。",
    alipayCode: "Alipay決済コード",
    wechatCode: "WeChat決済コード",
    realPrice: "リアルタイム価格",
    currencyExchange: "通貨両替",
    currencyExchangeIn: "通貨両替",
    cashableBalance: "残額を差し引くことができる：",
    minimumCashable: "最小両替可能：",
    maximCasheble: "最大両替可能：",
    automicallys: "両替をクリックしたら自動的に完成します。戻れません。",
    match: "対",
    title: "資産両替",
    HoldAsets: "保有資産",
    dangerousCurrency: "危険な貨幣を持っている",
    convertibleQuanntity: "両替可能数量",
    currencyExchanges: "貨幣両替率：",
    insuranceCurrency: "保険貨幣",
    insuranceType: "保険タイプ",
    contracctAset: "契約資産保険額",
    warehousses: "保険倉庫数量",
    availableAsets: "利用可能資産：",
    insuredAsssets: "被保資産：",
    insuredAsssets1: "被保資産",
    insuranceAsssets: "保険資産：",
    purrhaseInsurance: "保険申請",
    insurancCliaims: "保険賠償",
    insuranceCarcelation: "保険解約",
    coinWallet: "保険貨幣財布",
    bmbWallet: "HAP財布",
    cumullativeCoins: "累計生幣：",
    availableQuautity: "利用可能数量：",
    rawCurrency: "生幣記録",
    contracctInsurance: "契約保険",
    tentousand: "万",
    runningLow: "残高不足",
    purrhase:
      "あなたが入力した数量は規則に合わないです。あなたの購入限度額はあります。",
    reach: "はい",
    between: "間",
    onlyEnter: "あなたは入力しかできません。",
    integersBetween: "間の整数",
    notReturned:
      "保険の申し込みをクリックして、保険条約を詳しく知っています。そして保険倉庫の自動発効に同意して、戻ってきません",
    settled: "保険資産の損失を受けて注文できない時、保険賠償請求",
    profitable: "倍、当資産収益",
    terminated: "保険は自動的に解約されます。",
    automically:
      "保護資産の損失が50%の場合、保険賠償請求を申請しなければならない。さもなければ取引できなくなり、100%の利益が得られない場合、保険は自動的に解約され、保険倉庫は毎日2回だけ賠償し、2回を超えて、t+1は賠償します。",
    termination:
      "保険が解約された後、保険資産の方が両替できます。解約後は違約と見なされます。保険倉庫は自動的にゼロになります。",
    just: "正",
    back: "反",
    lowestNumber: "数量が一番低い",
    confirmExchange: "両替を確認しますか？",
    contracctValuation: "契約口座資産評価値",
    secondValuation: "秒契約口座資産評価値",
    falshValuation: "フラッシュ・アカウント資産評価値",
    c2cValuation: "C 2 C口座資産推定値",
    recordWithdrawal: "チャージ貨幣記録",
    category: "カテゴリ",
    safetyCenter: "安全センター",
    safeText1:
      "パスワードの登録、変更、およびセキュリティ設定の場合は検証メールを受け取ります",
    safeText2:
      "インターネットアカウントに盗難のリスクがあります。定期的にパスワードを変更して口座の安全を守ることをお勧めします。",
    flashTrading: "フラッシュ取引",
    assetCenter: "資産センター",
    promotionCode: "私のプロモーションコード",
    loginAgain: "登録が古いので、再登録してください",
    text10: "HAPベースのリアルタイム価格",
    text11: "授権コード",
  },
};

// WEBPACK FOOTER //
// ./src/lang/jp.js
